import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const FollowUpConfigurationAdminPageObjClass = Scrivito.provideObjClass(
  "FollowUpConfigurationAdminPage",
  {
    attributes: {
      ...defaultPageAttributes
    },
    extractTextAttributes: ["body"]
  }
)

export type FollowUpConfigurationAdminPageObj = InstanceType<
  typeof FollowUpConfigurationAdminPageObjClass
>
